import { type ReactNode } from 'react'
import { useAuthBootstrap } from 'shared/auth/hooks/useAuthBootstrap'
import { useSessionExpiry } from 'shared/auth/hooks/useSessionExpiry'
import { useAuthRedirect } from 'shared/auth/hooks/useAuthRedirect'

interface AuthGateProps {
  children: ReactNode
}

/**
 * 旧 AuthProvider の置き換え。Context は持たず、認証の副作用フックを起動するだけ。
 * 状態は jotai(authAtoms) + TanStack Query(userMe) に、遷移は guard に分離済み。
 * BrowserRouter / QueryClientProvider / jotai Provider の内側で描画する。
 */
export const AuthGate = ({ children }: AuthGateProps) => {
  useAuthBootstrap()
  useSessionExpiry()
  useAuthRedirect()
  return <>{children}</>
}
